import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild
} from "@angular/core";
import {CdkVirtualScrollViewport} from "@angular/cdk/scrolling";
import {TeamModel} from "../../../models/team.model";

require('./teams-table.scss');
@Component({
  standalone: false,
  selector: 'app-teams-table',
  templateUrl: './teams-table.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TeamsTableComponent implements OnInit, OnChanges {

  @Input() teams: TeamModel[];
  @Input() sortType: any;
  @Input() allowEdit: boolean;
  @Input() allowDelete: boolean;
  @Input() allowSort: boolean;
  @Output() reloadEvent = new EventEmitter<any>();
  @Output() fetchNextEvent = new EventEmitter<null>();
  @Output() editTeamEvent = new EventEmitter<TeamModel>();
  @Output() deleteTeamEvent = new EventEmitter<TeamModel>();
  @Output() sortTypeChangeEvent = new EventEmitter<string>();

  @ViewChild(CdkVirtualScrollViewport, {static: false})
  private cdkVirtualScrollViewport: CdkVirtualScrollViewport;

  public currentLastRowIndex: number;
  public asceDescIconsMap: any;

  constructor() {
  }

  ngOnInit() {
    this.asceDescIconsMap = {
      asc: 'sort-asc',
      desc: 'sort-desc',
      undefined: 'sort'
    };
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.teams && this.teams.length) {
      this.cdkVirtualScrollViewport?.checkViewportSize();
    }
  }

  getNextBatch() {
    if (this.cdkVirtualScrollViewport.measureScrollOffset('bottom') < 50) {
      this.fetchNextEvent.emit();
    }
  }


}
